(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-foto-clienti"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ds-photo-marquee')) {
    customElements.define('ds-photo-marquee', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.ds-photos__pause');
        this.togglePause = () => {
          const paused = this.classList.toggle('is-paused');
          this.button.setAttribute('aria-pressed', String(paused));
        };
        this.button?.addEventListener('click', this.togglePause);
        this.resize = new ResizeObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.build());
        });
        this.resize.observe(this);
        this.visibility = new IntersectionObserver(entries => {
          this.classList.toggle('is-offscreen', !entries[0].isIntersecting);
        });
        this.visibility.observe(this);
        this.selectBlock = event => {
          if (this.contains(event.target)) {
            this.classList.add('is-paused');
            this.button?.setAttribute('aria-pressed', 'true');
          }
        };
        document.addEventListener('shopify:block:select', this.selectBlock);
      }
      build() {
        this.classList.remove('is-ready');
        this.querySelectorAll('.ds-photos__row').forEach(row => {
          const track = row.querySelector('.ds-photos__track');
          const original = track.querySelector('[data-original]');
          track.querySelectorAll('[data-copy]').forEach(copy => copy.remove());
          original.querySelectorAll('[data-copy]').forEach(copy => copy.remove());
          original.style.width = '';
          const group = document.createElement('div');
          group.className = 'ds-photos__group';
          group.dataset.copy = '';
          group.setAttribute('aria-hidden', 'true');
          group.inert = true;
          const appendPhotos = () => {
            Array.from(original.children).forEach(card => {
              const copy = card.cloneNode(true);
              copy.removeAttribute('data-shopify-editor-block');
              group.appendChild(copy);
            });
          };
          appendPhotos();
          track.appendChild(group);
          let repeats = 0;
          while (group.getBoundingClientRect().width < row.clientWidth && repeats < 30) {
            appendPhotos();
            repeats++;
          }
          original.style.width = `${group.getBoundingClientRect().width}px`;
          const rest = Array.from(group.children).slice(original.children.length);
          original.querySelectorAll('[data-copy]').forEach(copy => copy.remove());
          rest.forEach(card => {
            card.dataset.copy = '';
            card.setAttribute('aria-hidden', 'true');
            original.appendChild(card.cloneNode(true));
          });
        });
        this.classList.add('is-ready');
      }
      disconnectedCallback() {
        this.resize?.disconnect();
        this.visibility?.disconnect();
        cancelAnimationFrame(this.frame);
        this.button?.removeEventListener('click', this.togglePause);
        document.removeEventListener('shopify:block:select', this.selectBlock);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
